import styled from 'styled-components';

const MenuTileGridContainer = styled.div`
  margin: 0;
  padding: 2rem 1rem 5rem 1rem;

  ${Styles.desktop`
    margin: 2rem;
    padding: 0;
  `}
`;

export const MenuListGridContainer = styled.div`
  margin: 0;

  ${Styles.desktop`
    margin: 2rem;
    padding: 0;
  `}
`;

export const MenuTileGridInner = styled.div<{ $isOnMainMenu?: boolean }>`
  display: grid;
  text-decoration: none;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  min-height: 250px;

  ${Styles.mobileLandscape`
    grid-template-columns: 1fr 1fr;
  `}

  ${Styles.desktop`
    grid-template-columns: 1fr 1fr 1fr;
    max-width: 1000px;
    margin: 0 auto;
  `}
`;

export const MenuListGridInner = styled.div<{ $isOnMainMenu?: boolean }>`
  display: grid;
  text-decoration: none;
  grid-template-columns: 1fr;

  ${Styles.desktop`
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1rem;
    max-width: 1000px;
    margin: 0 auto;
  `}
`;

export default MenuTileGridContainer;
